const EnhancedToolbarStyles = {
  '.itemsPerPageText': {
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '0',
    lineHeight: '24px',
    display: 'inline',
  },
  '.selectionPreviewPipe': {
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '0',
    display: 'inline',
    lineHeight: '24px',
    marginRight: '10px',
  },
  '.selectionPreviewPipePaginationSelected': {
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '0',
    display: 'inline',
    lineHeight: '24px',
    marginLeft: '130px',
  },
  '.itemsPerPagePopup': {
    visibility: 'hidden',
    opacity: 0,
    top: '0',
    left: '57px',
    right: '0',
    bottom: '0',
    position: 'absolute',
    height: '35px',
    width: '200px',
    borderRadius: '5px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.16)',
    alignContent: 'center',
  },
  '.itemsPerPageBadge': {
    margin: '5px',
    cursor: 'pointer',
  },
  '.tableSelectionPreviewComponent': {
    display: 'inline-block',
    position: 'relative',
    marginLeft: '25px',
  },
  '.tableSelectionPreview': {
    display: 'inline-block',
    position: 'relative',
  },
};

export default EnhancedToolbarStyles;
